/* eslint-disable */

import request from '@/utils/request'
import qs from 'qs'
export function getListHistoryForecast(query) {
  return request({
    url: '/report-service/v1/revenue-report/room-level',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getListHistoryForecastExcel(query) {
  return request({
    url: '/report-service/v1/revenue-report/room-level/excel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
